import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=36500605&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=js"
export * from "./CreateCard.vue?vue&type=script&lang=js"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=36500605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36500605",
  null
  
)

export default component.exports